import { Person } from "@mapmycustomers/shared/types/entity";

import { fetchPeople } from "@app/store/person/actions";

const fetchPeopleByIds = (
  personIds: Person["id"][],
  onFetchPeople: typeof fetchPeople
): Promise<Person[]> => {
  if (!personIds.length) {
    return Promise.resolve([]);
  }
  return new Promise((resolve) =>
    onFetchPeople({
      callback: (response) => resolve(response.data),
      options: {
        // Access info so userIds includes hierarchical-access users (e.g. team owners).
        $filters: {
          $and: [{ id: { $in: personIds } }],
          includeAccessStatus: true,
          includeUsersWithAccess: true,
        },
        $limit: personIds.length,
      },
    })
  );
};

export default fetchPeopleByIds;
